import React from 'react';

import { StreetAddress } from 'app/model/StreetAddress';
import { Reference } from 'app/model/Reference';
import { CommaSeparatedList } from 'app/logic/address/CommaSeparatedList';

export interface InlineAddressViewProps {
    /**
     * Адрес
     */
    address: StreetAddress;

    /**
     * Страна представленная значением справочника
     */
    country: Reference;

    /**
     * Тип населённого пункта
     */
    localityType: Reference;

    /**
     * Тип улицы
     */
    streetType: Reference;
}

/**
 * Строчное представление адреса.
 */
export const InlineAddressView = ({
    address,
    country,
    streetType,
    localityType,
}: InlineAddressViewProps) => (
    <div className={'inlineAddressView'}>
        <CommaSeparatedList
            values={[
                { prefix: address.postalCode },
                { postfix: country.name, reordered: true },
                { postfix: address.region, reordered: true },
                { postfix: address.district, prefix: 'РАЙОН', reordered: true },
                {
                    postfix: address.villageCouncil,
                    prefix: 'СЕЛЬСОВЕТ',
                    reordered: true,
                },
                { prefix: localityType.name, postfix: address.locality },
                { prefix: streetType.name, postfix: address.street },
                { prefix: 'ДОМ', postfix: address.house, reordered: true },
                {
                    prefix: 'КОРПУС',
                    postfix: address.building,
                    reordered: true,
                },
                { prefix: 'КВАРТИРА', postfix: address.flat, reordered: true },
            ]}
        />
    </div>
);
